module.exports = __webpack_public_path__ + "components/scroll-button/static/icon-chevron-circle-left-6577028d10159a34a24a95e7f525800d.svg";